import styled from 'styled-components';

import { MenuCheckboxItem } from '@creditornot/cb-menu';
import { ListingReason as ListingReasonType } from 'common/api-types/recommendations';
import { ThinScrollbarContainer } from 'common/components/cookbook/ThinScrollbarContainer';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

const ItemList = styled(ThinScrollbarContainer)`
  max-height: 400px;
  width: 320px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  & > * {
    flex-shrink: 0;
  }
`;

type Props = {
  onReasonChange: (reason: ListingReasonType) => void;
  selectedReasons: ListingReasonType[];
};

export const ListingReasons = ({ onReasonChange, selectedReasons }: Props) => {
  const f = useFormatMessage();
  const reasons: ListingReasonType[] = ['UNDERDEVELOPED', 'MISSING'];

  return (
    <ItemList role="menu">
      {reasons.map((reason) => (
        <MenuCheckboxItem
          role="checkbox"
          key={reason}
          onChange={() => onReasonChange(reason)}
          checked={selectedReasons.includes(reason)}
        >
          {f(`selection_recommendations.reasons:${reason}`)}
        </MenuCheckboxItem>
      ))}
    </ItemList>
  );
};
